import React, { FC } from 'react';

const IconHeartMatrona: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24px"
      height="23px"
      viewBox="0 0 24 23"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Icon</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Icon-/-Matrona-Caprabo"
        stroke="none"
        strokeWidth="1"
        // fill="none"
        fillRule="evenodd"
      >
        {/* <g */}
        {/*  id="Icon-/-Matrona-Caprabo" */}
        {/*  transform="translate(0.000000, -1.000000)" */}
        {/*  fill="#393D49" */}
        {/* > */}
        <path
          d="M7.50755556,3.3 C9.12,3.3 10.6311111,4.07648 11.6497778,5.43256 L12,5.89808 L12.352,5.43256 C13.3706667,4.07648 14.88,3.3 16.496,3.3 C19.4346667,3.3 21.8275556,5.87968 21.8275556,9.05 C21.8275556,11.79896 19.7795556,13.92048 17.8008889,15.97392 C17.4648889,16.32352 17.1324444,16.6676 16.8142222,17.01168 C15.3831111,18.55912 12.848,20.81128 12,21.55648 C11.152,20.81128 8.61866667,18.56096 7.18577778,17.01168 C6.86933333,16.6676 6.53511111,16.32168 6.19733333,15.97024 C4.22044444,13.91864 2.176,11.79712 2.176,9.05 C2.176,5.87968 4.56711111,3.3 7.50755556,3.3 M16.496,1 C14.8746667,1 13.2906667,1.56672 12,2.60264 C10.7111111,1.56672 9.13066667,1 7.50755556,1 C3.36711111,1 0,4.61008 0,9.05 C0,12.75576 2.47822222,15.33176 4.67911111,17.61704 C5.00622222,17.95376 5.328,18.28864 5.632,18.61984 C7.23733333,20.35312 10.0462222,22.83344 10.9102222,23.586 C11.216,23.85096 11.6035556,24 12,24 C12.4,24 12.7875556,23.85096 13.1342222,23.5492 C13.9573333,22.8316 16.768,20.35128 18.3662222,18.61984 C18.6737778,18.29048 18.9973333,17.95376 19.3333333,17.60784 C21.5217778,15.33544 24,12.7576 24,9.05 C24,4.61008 20.6346667,1 16.496,1"
          id="Icon"
        />
        {/* </g> */}
      </g>
    </svg>
  );
};

export default IconHeartMatrona;
